<template>
  <v-btn @click="onClick" small class="min-width">共有</v-btn>
</template>

<script>
export default {
  name: 'ButtonLink',
  methods: {
    onClick() {
      this.$emit('click')
    },
  },
}
</script>

<style scoped>
.min-width {
  min-width: 60px;
}
</style>
